module.exports = __webpack_public_path__ + "img/mastercard.afdbac97.svg";